/**
 * Shared inventory sub-navigation strip.  Rendered at the top of every
 * inventory-family route so users can jump between Products, Suppliers,
 * Purchase Orders, Kits, Reports, Analytics without visiting the sidebar.
 */
import { NavLink } from "react-router-dom";
import { LayoutGrid, Building2, ShoppingCart, Layers, FileBarChart, TrendingUp } from "lucide-react";

const TABS = [
  { to: "/app/inventory",              end: true, label: "Products",         icon: LayoutGrid,   testid: "inv-tab-products" },
  { to: "/app/inventory/treatment-kits", label: "Treatment Kits", icon: Layers,       testid: "inv-tab-kits" },
  { to: "/app/inventory/reports",      label: "Reports",          icon: FileBarChart, testid: "inv-tab-reports" },
  { to: "/app/inventory/analytics",    label: "Analytics",        icon: TrendingUp,   testid: "inv-tab-analytics" },
];

export default function InventoryTabs() {
  return (
    <div className="mb-6 -mx-4 sm:mx-0 overflow-x-auto" data-testid="inventory-subnav">
      <div className="inline-flex gap-1 border border-[#E8EAE9] rounded-full bg-white p-1 text-sm min-w-max">
        {TABS.map(t => (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
                   className={({ isActive }) =>
                     `inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full whitespace-nowrap transition-colors ${
                       isActive ? "bg-pine text-linen" : "text-ink-mid hover:text-ink"
                     }`}>
            <t.icon className="w-3.5 h-3.5" /> {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
